import { Link } from "@mui/material";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { WhatsappOverviewMessages } from "@/messages/platforms/whatsappConnection/whatsappOverviewMessages";

interface Props {
  messages: WhatsappOverviewMessages;
}

export function Overview({ messages }: Props) {
  return (
    <MDBox>
      <MDBox width="82%" textAlign="left" mx="auto" my={4}>
        <MDBox mb={1}>
          <MDTypography variant="h5" fontWeight="regular">
            {messages.whatsappOverviewText1}
          </MDTypography>
        </MDBox>
        <MDTypography variant="body2" color="text">
          {messages.whatsappOverviewText2}
        </MDTypography>

        <MDTypography variant="body2" color="text">
          {messages.whatsappOverviewText3}
          <Link target="_blank" href={messages.whatsappOverviewArticleLinkSource}>
            <MDTypography component="span" variant="body2" fontWeight="bold" color="primary">
              {messages.whatsappOverviewArticleLinkText}
            </MDTypography>
          </Link>
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}
